import * as d3 from "d3";

export const locale = d3.timeFormatDefaultLocale({
  decimal: ",",
  thousands: ".",
  grouping: [3],
  currency: ["€", ""],
  dateTime: "%a %b %e %X %Y",
  date: "%d-%m-%Y",
  time: "%H:%M:%S",
  periods: ["AM", "PM"],
  days: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
  shortDays: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
  months: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Maa",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
});

export const timeplotLocale = d3.timeFormatDefaultLocale({
  decimal: ",",
  thousands: ".",
  grouping: [3],
  currency: ["€", ""],
  dateTime: "%a %b %e %X %Y",
  date: "%d.%m.%Y",
  time: "%H:%M:%S",
  periods: ["AM", "PM"],
  days: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
  shortDays: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  months: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
  shortMonths: [
    "",
    "jan",
    "",
    "maa",
    "",
    "mei",
    "",
    "jul",
    "",
    "sep",
    "",
    "nov",
    "",
  ],
});

export const months = [
  "januari",
  "februari",
  "maart",
  "april",
  "mei",
  "juni",
  "juli",
  "augustus",
  "september",
  "oktober",
  "november",
  "december",
];